import React from 'react';

const FileChangeStatCard = ({ label, value }) => (
  <div className="rounded-xl border border-border/35 bg-transparent px-5 py-4">
    <div className="text-[12px] font-medium text-muted-foreground">{label}</div>
    <div className="mt-2 text-4xl font-semibold text-foreground">{value}</div>
  </div>
);

export default FileChangeStatCard;
